<template>
    <v-chart class="chart" :option="option"/>
</template>

<script>
    import {use} from "echarts/core";
    import {CanvasRenderer} from "echarts/renderers";
    import {LineChart} from "echarts/charts";
    import {GridComponent} from 'echarts/components';
    import {
        TitleComponent,
        TooltipComponent,
        ToolboxComponent,
        LegendComponent
    } from "echarts/components";
    import VChart, {THEME_KEY} from "vue-echarts";

    use([
        CanvasRenderer,
        LineChart,
        GridComponent,
        TitleComponent,
        TooltipComponent,
        ToolboxComponent,
        LegendComponent
    ]);

    export default {
        name: "lineChart",
        components: {
            VChart
        },
        provide: {
            [THEME_KEY]: "light"
        },
        data() {
            return {
                option: {
                    title: {
                        text: '最近预约'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['铭德医院', '北大健康西城分院', '北大健康东城分院']
                    },
                    grid: {
                        left: '5%',
                        right: '14%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '铭德医院',
                            type: 'line',
                            stack: 'Total',
                            data: [0, 0, 0, 0, 0, 0, 0]
                        },
                        {
                            name: '北大健康西城分院',
                            type: 'line',
                            stack: 'Total',
                            data: [0, 0, 0, 0, 0, 0, 0]
                        },
                        {
                            name: '北大健康东城分院',
                            type: 'line',
                            stack: 'Total',
                            data: [0, 0, 0, 0, 0, 0, 0]
                        }
                    ]
                }
            };
        }
    };
</script>

<style scoped>
    .chart {
        width: 100%;
        height: 400px;
    }
</style>
